let isMobile = false; //initiate as false
// device detection
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
  isMobile = true;
}
$(document).ready(function(){
    $(".hint").on({
        mouseenter: function () {
            $(".slider-overlay").fadeIn();
        },
        mouseleave: function () {
            $(".slider-overlay").hide();
        }});
   /* $(".show_video").on({
        mouseenter: function () {
            let id=$(this).data('id');
            $("#img_"+id).hide();
            $("#video_"+id).removeClass('d-none');
            $("#video_"+id).trigger('play');
        },
        mouseleave: function () {
            let id=$(this).data('id');
            $("#img_"+id).show();
            $("#video_"+id).addClass('d-none');
            $("#video_"+id).trigger('pause');
        }});*/
    $("#b_menu").on('click',function(){
        $("#navbarSupportedContent").fadeIn();
    });
    $("#close_menu").on('click',function(){
        $("#navbarSupportedContent").fadeOut();
    });
    $(".search-box").on('click',function(){
        var target=$(this).data('target');

        if($("#"+target).hasClass('active')){
            $("#"+target).removeClass('active');
        }else{
          $(".drop-search").removeClass('active');
            $("#"+target).addClass('active');
        }
    });
    $("#sizes").slider({ id: "sliderSizes", min: $("#sizes").data('low'), max: $("#sizes").data('high'), range: true, value: [$("#sizes").data('low'), $("#sizes").data('high')],tooltip_position:'bottom' });



    $('#properties').carousel({
        interval: 5000
    })

    $('.carousel-properties .carousel-item').each(function() {
        var minPerSlide = 3;
        var next = $(this).next();
        if (!next.length) {
            next = $(this).siblings(':first');
        }
        next.children(':first-child').clone().appendTo($(this));

        for (var i = 0; i < minPerSlide; i++) {
            next = next.next();
            if (!next.length) {
                next = $(this).siblings(':first');
            }

            next.children(':first-child').clone().appendTo($(this));
        }
    });
    if(show_thanks==1){
        $("#Thanks").modal('show');
    }

    $("#show_tour").on('click',function(){
        $(".boxes").addClass('hide');
        var id=$(this).data('id');
        $("#"+id).removeClass('hide');
    });
    $("#show_gallery").on('click',function(){
        $(".boxes").addClass('hide');
        var id=$(this).data('id');
        $("#"+id).removeClass('hide');
    });
    $("#show_video").on('click',function(){
        $(".boxes").addClass('hide');
        var id=$(this).data('id');
        $("#"+id).removeClass('hide');
    });

    $('#cubeSpinner').impulseslider({
        height: 650,
        width: 1366 ,
        depth: 500,
        perspective: 8000,
        pauseTime: 5000,
        transitionDuration: 1500,
        transitionEffect: "linear",
        autostart: false,
        rightSelector: ".right",
        leftSelector: ".left",
        directionRight: true,
        containerSelector: "#cubeCarousel",
        spinnerSelector: "#cubeSpinner"
    });



    if(home=="1"){
      HomeMap();
      $( window ).on( "orientationchange", function( event ) {
        HomeMap();
      });
    }
    $(".max-search :checkbox").each(function(e){
      $(this).prop( "checked", false );
    });
  $('.zoom').zoom({url: $(this).data('zoom')});
    $("#filter_project").on('change',function(){
      window.location.href=$(this).val();
    });
    let right_side_open=0;
    $("#sizes").on('change',function (){
      $("#sizes_all").removeAttr('checked');
    });
    $("#social_icon").on('click',function (){
      if(right_side_open==0){
        right_side_open=1;
        $(".right-side").css('right','0');
      }else{
        right_side_open=0;
        $(".right-side").css('right','-45px');
      }
    });
    $(".map_filter").on('change',function(){

      let id=$(this).data('id');
      if($(this).is(":checked")){
        $("#type_"+id).removeClass('hide');
      }else{
        $("#type_"+id).addClass('hide');
      }
      if(!$(this).data('parent') || id==20){
        $("#project_image").hide();
      }else{
        if($(this).is(':checked')){

        }else{
          $("#project_image").show();
        }
      }
      if($(this).is(':checked')){
        $("#sub_"+id).removeClass('d-none');

      }else{

        $("#sub_"+id).addClass('d-none');
        $("#sub_"+id+" :checkbox").each(function(e){
          var id=$(this).data('id');
          $("#"+id).addClass('hide');
          $("#type_"+id).addClass('hide');
          $(this).prop( "checked", false );
        });
      }
    });
    $("#plots_all").on('change',function(){
      if($(this).is(':checked')){
        $("#s_plots_div :checkbox").each(function(e){
          $(this).prop( "checked", true );
        });
      }else{
        $("#s_plots_div :checkbox").each(function(e){
          $(this).prop( "checked", false );
        });
      }
    });
  $("#categories_all").on('change',function(){
    if($(this).is(':checked')){
      $("#s_villas_div :checkbox").each(function(e){
        $(this).prop( "checked", true );
      });
    }else{
      $("#s_villas_div :checkbox").each(function(e){
        $(this).prop( "checked", false );
      });
    }
  });
  let current="";
  $(".sub-menu-link").on('dblclick', function(e) {
    e.preventDefault();
    let url=$(this).attr('href');
    window.location.href=url;
  });
  if(isMobile==true){
    $(".sub-menu-link").on('click',function (e){
      e.preventDefault();
      let id=$(this).data('id');
      if($(this).hasClass( "sub-menu-link-red" )){
        $("#sub_menu_"+id).fadeOut();
        $(this).removeClass('sub-menu-link-red');
      }else{
        $("#sub_menu_"+id).fadeIn();
        $(this).addClass('sub-menu-link-red');
      }

    });
  }else{
    $(".sub-menu-link").hover(function(){
      current=$(this);
      let id=current.data('id');
      $("#sub_menu_"+id).fadeIn();
      current.addClass('sub-menu-link-red');
    },function (){
      let id=current.data('id');
      $("#sub_menu_"+id).hover(function(){
        current.addClass('sub-menu-link-red');
      },function(){
        let id=current.data('id');
        $("#sub_menu_"+id).fadeOut();
        current.removeClass('sub-menu-link-red');
      });

    });
  }
  $(".c_plots").on('change',function(){
    let url=$(this).val();
    if(url){
      window.location.href=url;
    }
  });


});

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function HomeMap(){
    return null;
  $("#map").html('');
  let sWidth=screen.width;
  $.ajax({
    method: "GET",
    url: map_url,
    data: { sWidth: sWidth }
  }).done(function( msg ) {
    $("#map").html(msg);
    let filter_open=0;
    $("input:checkbox[rel='filter']").on('change',function(){
      $(".cTooltip").hide();
      $("input:checkbox[rel='filter']:checked").each(function(){

        let id=$(this).val();
        $("a[rel='point_"+id+"']").show();
      });
    });
    $("#filter_arrow").on('click',function(){
      if(filter_open==0){
        $("#filter_arrow_i").removeClass('fa-chevron-down');
        $("#filter_arrow_i").addClass('fa-chevron-up');
        filter_open=1;
        let height=$(".real-content").height() + 10;
        $(".filter-content").animate({height: height},500);
      }else{
        $("#filter_arrow_i").removeClass('fa-chevron-up');
        $("#filter_arrow_i").addClass('fa-chevron-down');
        $(".filter-content").animate({height:0},500);
        filter_open=0;
      }
    });

    $(document).scroll(function (){
      let top=$("#home-map-div").position().top;
      let document=$(window).scrollTop();
      let current=document + 150;
      if(current > top){
        let move = current - top;
        $("#home-map-filter").css('top',move+'px');
      }else{
        $("#home-map-filter").css('top','100px');
      }

    });
  });
}
